import { useCollection } from '@cloudscape-design/collection-hooks';
import {
  Box,
  Container,
  Table,
  SpaceBetween,
  Button,
  Header,
  Modal,
  FormField,
  Input,
  Pagination,
  Multiselect,
  ToggleButton,
  Toggle
} from '@cloudscape-design/components';
import { documentTableItem, FolderItem } from '../lib/models/interfaces';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ProjectContext } from '../context/projectContext';
import { DocumentContext } from '../context/documentContext';
import { UserContext } from '../context/authContext';

import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import axios from 'axios';
import { manageShare } from '../helpers/manageShareHelpers';
// import { HelpContext } from '../context/helpContext';
import {
  BackAndHomeButtons,
  BreadcrumbsPills
} from './Components/shared/backAndHomeButtons';
import { createLogger } from '../helpers/Logger';
import { useAlert } from '../context/alertContext';
import { Link2Off } from 'lucide-react';
import ButtonCollection, {
  ButtonConfig
} from './Components/shared/buttonCollection';
import { ScrollDownArrow } from './Components/shared/scrollDownArrow';

const logger = createLogger({ prefix: '[Folder]' });

export const FolderTableView = () => {
  const {
    selectedProjects,
    mainProjects,
    setSelectedProjects,
    createNewFolder,
    setFolderName,
    folderName,
    createFolderLoading,
    updateFolder,
    newFolderModalVisible,
    setNewFolderModalVisible,
    deleteFolder,
    allFolders,
    selectedFolders,
    setSelectedFolder,
    setProjectIdContext,
    folderDescription,
    setFolderDescription,
    currentProjectFolders,
    deleteLoadingFolder
  } = useContext(ProjectContext);
  const { allDocuments, setAllDocuments, setCurrentFolder, getAllDocs } =
    useContext(DocumentContext);
  // const { viewed, setTourType, setShowTourStartPage } = useContext(HelpContext);
  const { users, auth, user, isDeveloper } = useContext(UserContext);
  const { folderId, projectId } = useParams();
  const { setAlert } = useAlert();
  const [modalType, setModalType] = useState<string>('');
  const [selectedItemsTemp, setSelecetedItemsTemp] = useState<FolderItem[]>([]);
  const [shareModalVisible, setShareModalVisible] = useState<boolean>(false);
  const [selectedShare, setSelectedShare] = useState<OptionDefinition[]>([]);
  const [shareDocLoading, setShareDocLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleReset = () => {
    setNewFolderModalVisible(false);
    setFolderName('');
  };

  const containerRef = useRef<HTMLDivElement>(null);

  const {
    items,
    actions,
    filteredItemsCount,
    collectionProps,
    filterProps
    // paginationProps
  } = useCollection(currentProjectFolders, {
    filtering: {
      empty: <Box>Nothing</Box>,
      noMatch: <Box>No matches</Box>
    },
    // pagination: { pageSize: 10 },
    sorting: {},
    selection: {}
  });
  const selectedFolderPermissions = () => {
    const permissionsList = selectedItemsTemp![0]!.permissions;
    const tempOptionsList = permissionsList.map((member) => {
      return {
        label: member.name,
        value: member.sub
      };
    });
    setSelectedShare([...tempOptionsList]);
  };

  useEffect(() => {
    if (selectedItemsTemp.length > 0) {
      setSelectedFolder(selectedItemsTemp);
    } else {
      setSelectedFolder([]);
    }
    if (selectedItemsTemp.length === 1) {
      selectedFolderPermissions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemsTemp]);
  useEffect(() => {
    const pathArray = location.pathname.split('/');
    console.log('path name', pathArray);
    const project_Id = pathArray[3];
    const folder_Id = pathArray[5];
    if (project_Id && mainProjects.length > 0) {
      const projectToSet = mainProjects.filter((p) => p._id === project_Id);
      setSelectedProjects(projectToSet);
    }
    if (folder_Id && allFolders.length > 0) {
      const folderToSet = allFolders.filter((f) => f._id === folder_Id);
      setSelectedFolder(folderToSet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const setInfo = () => {
    if (!folderId) {
      // if (currentProjectFolders.length === 1) {
      //   setSelecetedItemsTemp([currentProjectFolders[0]]);
      // } else {
      //   setSelectedFolder([]);
      // }
    } else {
      const folderSelected = currentProjectFolders.filter(
        (ele) => ele._id === folderId
      );
      setSelecetedItemsTemp(folderSelected);
    }
    if (projectId) {
      setProjectIdContext(projectId);
    }
  };
  logger.info('folderId', folderId);

  const canDeleteFolder = useMemo(() => {
    if (selectedItemsTemp?.length > 0) {
      const folderDocs = allDocuments.filter(
        (ele) => ele.folder === selectedItemsTemp[0]?._id
      );
      logger.info('no of docs', folderDocs.length);
      if (folderDocs.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemsTemp]);

  useEffect(() => {
    setInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderId, selectedProjects]);

  const countDocuments = (folderId: string) => {
    const thisFolderDocuments = allDocuments.filter(
      (ele) => ele.folder === folderId
    );
    return thisFolderDocuments.length;
  };

  const handleSave = () => {
    if (modalType === 'CREATE') {
      createNewFolder();
    }
    if (modalType === 'EDIT') {
      updateFolder(selectedFolders[0]._id);
    }
    getAllDocs();
  };

  const handleShareModalCancel = () => {
    setShareDocLoading(false);
    setShareModalVisible(false);
    setSelectedShare([]);
  };

  const updateShare = async () => {
    if (!selectedItemsTemp) return;
    try {
      setShareDocLoading(true);
      logger.info('original', selectedItemsTemp[0].permissions);
      logger.info('new', selectedShare);
      const getChanges = manageShare(
        selectedItemsTemp[0].permissions.map((ele) => {
          return { value: ele.sub, label: ele.name };
        }),
        selectedShare
      );
      const reqBody: any = {
        _id: selectedItemsTemp[0]._id,
        projectId: selectedItemsTemp[0].project,
        remove: getChanges.removedItems.map((ele) => {
          return {
            sub: ele.value,
            action: 'view',
            name: ele.label
          };
        }),
        add: getChanges.addedItems.map((ele) => {
          return {
            sub: ele.value,
            action: 'view',
            name: ele.label
          };
        })
      };
      if (selectedItemsTemp[0].inheritPermissions === false) {
        reqBody.newInheritance = false;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_KORU_API}/share?type=folder`,
        reqBody,
        auth
      );
      logger.info('reqBody', reqBody);
      // update the specific documents permissions
      // const updatedItem = response.data.result;
      // const tempDocs = allDocuments;
      // const specificDocIndex = tempDocs.findIndex(
      //   (ele) => ele._id === updatedItem._id
      // );
      // if (specificDocIndex !== -1) {
      //   tempDocs[specificDocIndex].permissions = updatedItem.permissions;
      // }
      // setAllDocuments([...tempDocs]);

      // logger.info('result', response.data);
      getAllDocs();
      setShareDocLoading(false);
      setShareModalVisible(false);
      setSelectedShare([]);
      setSelecetedItemsTemp([]);
    } catch (e) {
      const error = e as Error;
      logger.error('Update error ', error.message);
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        setAlert('You are not authorized to perform this action', 'error', 3);
      }
      setShareModalVisible(false);
      setShareDocLoading(false);
      setSelecetedItemsTemp([]);
    }
  };
  const handleDeleteFolder = async () => {
    try {
      deleteFolder(selectedFolders[0]._id);
      getAllDocs();
    } catch (e) {
      logger.error(e);
    }
  };

  const buttonsInfo: ButtonConfig[] = useMemo(
    () => [
      {
        label: 'Create Folder',
        buttonFunctions: () => {
          setNewFolderModalVisible(true);
          setModalType('CREATE');
        },
        type: 'main',
        variant: 'primary',
        disabled:
          selectedProjects.length !== 1 ||
          !selectedProjects[0]?.permissions?.some(
            (permission) => permission.sub === user.sub
          )
      },
      {
        label: 'Edit Folder',
        buttonFunctions: () => {
          setNewFolderModalVisible(true);
          setModalType('EDIT');
          setFolderName(selectedFolders[0].folderName);
        },
        type: 'additional',
        variant: 'normal',
        disabled: selectedFolders.length !== 1,
        wrapperText: 'Edit Folder Name or Description'
      },

      {
        label: 'Delete',
        buttonFunctions: () => {
          handleDeleteFolder();
        },
        type: 'additional',
        variant: 'normal',
        disabled:
          selectedFolders.length !== 1 ||
          allDocuments.filter((d) => d.folder === selectedFolders[0]?._id)
            .length > 0,
        wrapperText: 'Empty Folders can be deleted'
      },
      {
        label: 'Share',
        buttonFunctions: () => setShareModalVisible(true),
        type: 'additional',
        variant: 'normal',
        disabled: selectedFolders.length !== 1,
        wrapperText: 'Update Folder Permissions'
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedFolders, selectedProjects, allDocuments]
  );

  return (
    <>
      <div className="p-2">
        {/* <BackAndHomeButtons
          showBackButton={true}
          currentFolder={null}
          projectId={selectedProjects[0]?._id}
        /> */}
        <BreadcrumbsPills />
      </div>
      <Container
        header={
          <Header
            description="Select a folder to view of manage documents"
            actions={<ButtonCollection buttons={buttonsInfo} />}
          >
            <SpaceBetween size={'s'} direction="horizontal">
              <Box variant="h1">Project Folders</Box>
              {/* {isDeveloper &&  <Box>{selectedProjects[0]?.projectType}</Box>} */}
            </SpaceBetween>
          </Header>
        }
      >
        <div
          style={{
            maxHeight: '25vh',
            overflowY: 'scroll',
            scrollbarWidth: 'none'
          }}
          ref={containerRef}
        >
          <Table
            stickyHeader
            variant="borderless"
            data-tour-id="folderTable"
            header={
              <Header>
                <div>{`Project: ${selectedProjects[0]?.projectName}`}</div>
              </Header>
            }
            {...collectionProps}
            items={items}
            // pagination={<Pagination {...paginationProps} />}
            columnDefinitions={[
              {
                id: 'title',
                header: 'Folder',
                cell: (item: FolderItem) => item.folderName,
                sortingField: 'documentFileName',
                maxWidth: '400px'
              },
              {
                id: 'description',
                header: 'Description',
                cell: (item) => item.folderDescription
              },
              {
                id: 'docCount',
                header: 'Documents',
                cell: (item: FolderItem) => countDocuments(item._id)
              },
              {
                id: 'permission',
                header: 'Access',
                cell: (item: FolderItem) =>
                  `${item.permissions.map((ele) => ele.name).join(' , ')}`
              },
              {
                id: 'inheritance',
                header: 'Inherits Access',
                maxWidth: '10%',
                verticalAlign: 'middle',
                cell: (item: FolderItem) =>
                  !item.inheritPermissions ? <Link2Off size={16} /> : null
              }
            ]}
            selectionType="multi"
            selectedItems={selectedItemsTemp}
            onSelectionChange={({ detail }) => {
              setSelecetedItemsTemp(detail.selectedItems);
            }}
          />
          <ScrollDownArrow
            containerRef={containerRef as React.RefObject<HTMLElement>}
            bottomValue={'7%'}
          />
        </div>
      </Container>
      <Modal
        visible={newFolderModalVisible}
        onDismiss={() => handleReset()}
        header={modalType === 'EDIT' ? 'Edit Folder Name' : 'Create New Folder'}
        footer={
          <SpaceBetween size={'s'} direction="horizontal" alignItems="end">
            <Button onClick={() => handleReset()}>Cancel</Button>
            <Button onClick={() => handleSave()} loading={createFolderLoading}>
              Save
            </Button>
          </SpaceBetween>
        }
      >
        <FormField label="Folder Name">
          <Input
            value={folderName}
            onChange={(event) => setFolderName(event.detail.value)}
          />
        </FormField>
        <FormField label="Folder Description">
          <Input
            value={folderDescription}
            onChange={(event) => setFolderDescription(event.detail.value)}
          />
        </FormField>
      </Modal>
      <Modal
        size="large"
        visible={shareModalVisible}
        onDismiss={() => handleShareModalCancel()}
        header={'Share Folder Access'}
        footer={
          <div className="w-full flex justify-between">
            <div className="space-x-2">
              <Button onClick={() => handleShareModalCancel()}>Cancel</Button>
              <Button onClick={() => updateShare()} loading={shareDocLoading}>
                Save Access
              </Button>
            </div>
            <div>
              <Toggle
                checked={selectedItemsTemp[0]?.inheritPermissions}
                onChange={({ detail }) =>
                  setSelecetedItemsTemp((prev) =>
                    prev.map((item) => ({
                      ...item,
                      inheritPermissions: detail.checked
                    }))
                  )
                }
              >
                Use Project Access
              </Toggle>
            </div>
          </div>
        }
      >
        <div
          style={{
            height: '40vh'
          }}
        >
          <p>
            Choose who can access this folder. Access applies to all documents
            inside this folder.
          </p>
          <Multiselect
            onChange={({ detail }) =>
              setSelectedShare([...detail.selectedOptions])
            }
            selectedOptions={selectedShare}
            placeholder="Users"
            options={users.map((ele) => {
              return {
                label: ele.name,
                value: ele.sub
                // disabled: ele.sub === user.sub
              };
            })}
          ></Multiselect>
        </div>
      </Modal>
    </>
  );
};
